import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { useCheckoutContext } from './index'
export const ShippingAddressDisplay = () => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions
  return (
    <React.Fragment>
      <div>{shippingOptions?.shippingAddress?.street1 ?? ''}</div>
      <div>{shippingOptions?.shippingAddress?.street2 ?? ''}</div>
      <div>{shippingOptions?.shippingAddress?.street3 ?? ''}</div>
      <div>
        {shippingOptions?.shippingAddress?.city ?? ''}, {shippingOptions?.shippingAddress?.state ?? ''}{' '}
        {shippingOptions?.shippingAddress?.zip ?? ''}
      </div>
      <div>{shippingOptions?.shippingAddress?.country ?? ''}</div>

      <ShowIf condition={!!shippingOptions.phone}>
        <div>{shippingOptions?.phone ?? ''}</div>
      </ShowIf>
    </React.Fragment>
  )
}
